import { internal, template } from '../../vendor/elix.js';

function TpSelectFilledMixin(Base) {

  return class TpSelectFilled extends Base {

    get [internal.template]() {

      const innerSelector = this.innerSelector || '#inner';

      return template.concat(

        super[internal.template],

        template.html`
          <style>

            .inputStateContainer ${innerSelector} {
              padding: var(--tp-filled-select-mixin-padding);
            }

            .inputStateContainer:not(.focused):not(.error):not(:hover) ${innerSelector}.empty,
            .inputStateContainer.disabled ${innerSelector}.empty {
              border-bottom-left-radius: 0px;
              border-bottom-right-radius: 0px;
            }

            .inputStateContainer:not(.focused):not(.disabled):not(.error) ${innerSelector}.empty,
            .inputStateContainer.disabled ${innerSelector} {
              border-bottom-width: var(--tp-filled-select-mixin-border-width-empty);
              border-bottom-color: var(--tp-filled-select-mixin-border-color-empty);
            }
            
            .inputStateContainer:not(.focused):not(.disabled):not(.error):hover ${innerSelector}.empty {
              border-bottom-color: var(--tp-filled-select-mixin-border-color-hover);
            }

            .inputStateContainer.disabled ${innerSelector} {
              border-bottom-color:  var(--tp-filled-select-mixin-border-color-disabled);
            }

            .inputStateContainer:not(.disabled) ${innerSelector}:focus,
            .inputStateContainer:not(.disabled) ${innerSelector}:active {
              background-color: var(--tp-filled-select-mixin-background-color-focused);
            }

          </style>
        `
      );

    }

  }

}

export default TpSelectFilledMixin;
